import { gql } from 'urql';

const DELETE_ACTION_COMMENT = gql`
  mutation DeleteActionComment($commentId: Int!, $id: Int!, $activity: String, $timestamp: bigint, $userId: Int) {
    delete_action_comments_by_pk(id: $commentId) {
      id
    }
    insert_actions_activity_one(
      object: { activity: $activity, entity_id: $id, timestamp: $timestamp, user_id: $userId }
    ) {
      id
    }
  }
`;

export default DELETE_ACTION_COMMENT;
